export default [
    {
        path: '/produccion/transacciones/transferenciasMP/ingresos',
        name: 'produccion-transacciones-transferencias-ingresos',
        component: () => import('@/views/pages/produccion/transacciones/IngresoMateriaPrima.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.ingresos_materia_prima.title',
            resource: 'Produccion',
            action: 'ver-produccion-ingreso-materia-prima',
            pageTitle: 'Ingreso Materia Prima',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Ingreso de Materia Prima',
                    active: true,
                },
                {},
            ],
        },
    },
    {
        path: '/produccion/transacciones/transferenciasMP/egresos',
        name: 'produccion-transacciones-transferencias-egresos',
        component: () => import('@/views/pages/produccion/transacciones/EgresoMateriaPrima.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.egresos_materia_prima.title',
            resource: 'Produccion',
            action: 'ver-produccion-egreso-materia-prima',
            pageTitle: 'Egreso Materia Prima',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Egreso de Materia Prima',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/reportes/transferenciasMP/kardex',
        name: 'produccion-reportes-transferenciaMP-kardex',
        component: () => import('@/views/pages/produccion/informes/reporteKardex.vue'),
        meta: {
            title: 'i18n:produccion.informes.kardex.title',
            resource: 'Produccion',
            action: 'ver-produccion-kardex',
            pageTitle: 'Kardex',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Kardex',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/reportes/rotacionCamaron',
        name: 'reporte-rotacion-camaron',
        component: () => import('@/views/pages/produccion/informes/reporteRotacionCamaron.vue'),
        meta: {
            title: 'i18n:produccion.informes.rotacion_camaron.title',
            resource: 'Produccion',
            action: 'ver-produccion-rotacion-camaron',
            pageTitle: 'Rotacion Camaron',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Rotacion Camaron',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/generacionEtiqueta',
        name: 'produccion-canasta-etiqueta',
        component: () => import('@/views/pages/produccion/mantenimiento/GeneracionEtiqueta.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.generacion_etiqueta.title',
            resource: 'Produccion',
            action: 'ver-produccion-generacion-etiqueta',
            pageTitle: 'Generacion Etiqueta',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Generacion Etiqueta',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/anulacionEtiqueta',
        name: 'produccion-anulacion-etiqueta',
        component: () => import('@/views/pages/produccion/transacciones/anulacionEtiqueta.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.anulacion_etiqueta.title',
            resource: 'Produccion',
            action: 'ver-produccion-anulacion-etiqueta',
            pageTitle: 'Anulacion Etiqueta',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Anulacion Etiqueta',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/consultarLote',
        name: 'produccion-consultar-lote',
        component: () => import('@/views/pages/produccion/transacciones/consultarLote.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.consultar_lote.title',
            resource: 'Produccion',
            action: 'ver-produccion-consultar-lote',
            pageTitle: 'Consultar Lote',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Consultar Lote',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/trazabilidadEtiqueta',
        name: 'produccion-trazabilidad-etiqueta',
        component: () => import('@/views/pages/produccion/transacciones/trazabilidadEtiqueta.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.trazabilidad_etiqueta.title',
            resource: 'Produccion',
            action: 'ver-produccion-trazabilidad-etiqueta',
            pageTitle: 'Trazabilidad Etiqueta',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Trazabilidad Etiqueta',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteLibras',
        name: 'produccion-reporte-libras',
        component: () => import('@/views/pages/produccion/informes/reporteLibras.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_libras.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-libras',
            pageTitle: 'Reporte Libras',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Libras',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteEtiquetasAnuladas',
        name: 'produccion-informe-etiquetas-anuladas',
        component: () => import('@/views/pages/produccion/informes/reporteEtiquetasAnuladas.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_etiquetas_anuladas.title',
            resource: 'Produccion',
            action: 'ver-produccion-informe-etiquetas-anuladas',
            pageTitle: 'Reporte Etiquetas Anuladas',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Etiquetas Anuladas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteLibrasProceso',
        name: 'produccion-reporte-libras-proceso',
        component: () => import('@/views/pages/produccion/informes/reporteLibrasXProceso.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_libras_proceso.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-libras-proceso',
            pageTitle: 'Reporte Libras X Proceso',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Libras X Proceso',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteLibrasBodega',
        name: 'produccion-reporte-libras-bodega',
        component: () => import('@/views/pages/produccion/informes/reporteLibrasXBodega.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_libras_bodega.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-libras-bodega',
            pageTitle: 'Reporte Libras X Bodega',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Libras X Bodega',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteEtiquetasXLote',
        name: 'produccion-reporte-etiquetas-lote',
        component: () => import('@/views/pages/produccion/informes/reporteEtiquetasXLote.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_etiquetas_lote.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-etiquetas-lote',
            pageTitle: 'Reporte Etiquetas X Lote',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Etiquetas X Lote',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteEtiquetasXArea',
        name: 'produccion-reporte-etiquetas-area',
        component: () => import('@/views/pages/produccion/informes/reporteEtiquetasXArea.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_etiquetas_area.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-etiquetas-area',
            pageTitle: 'Reporte Etiquetas X Area',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Etiquetas X Area',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/registrocabinplant',
        name: 'produccion-registro-cabinplant',
        component: () => import('@/views/pages/produccion/transacciones/registroCabinPlantControl.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.registro_cabinplant.title',
            resource: 'Produccion',
            action: 'ver-produccion-cabinplant',
            pageTitle: 'Registro CabinPlant',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Registro CabinPlant',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteMovBines',
        name: 'produccion-reporte-movimiento-bines',
        component: () => import('@/views/pages/produccion/informes/reporteMovBines.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_movimiento_bines.title',
            resource: 'Produccion',
            action: 'ver-produccion-movimiento-bines',
            pageTitle: 'Reporte Movimiento Bines',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Movimiento Bines',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteRendimiento',
        name: 'produccion-reporte-rendimiento',
        component: () => import('@/views/pages/produccion/informes/reporteRendimientoDescabezado.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_rendimiento.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-rendimiento',
            pageTitle: 'Reporte Rendimiento',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Rendimiento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteTiemposEspera',
        name: 'produccion-reporte-tiempoEspera',
        component: () => import('@/views/pages/produccion/informes/reporteTiemposEspera.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_tiempos_espera.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-tiempoEspera',
            pageTitle: 'Reporte Tiempo de Espera',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Rendimiento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteTiemposPlantaRecepcion',
        name: 'produccion-reporte-TiemposPlantaRecepcion',
        component: () => import('@/views/pages/produccion/informes/reporteTiemposPlantaRecepcion.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_tiempos_planta_recepcion.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-TiemposPlantaRecepcion',
            pageTitle: 'Reporte Tiempo Planta a Recepción',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Tiempo Planta a Recepción',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteModificaciones-anulaciones',
        name: 'produccion-reporte-modifica-anula',
        component: () => import('@/views/pages/produccion/informes/reporteModificaciones_Anulaciones.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_modificaciones_anulaciones.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-modif-anula',
            pageTitle: 'Control de Modificaciones o Anulaciones',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Control de Modificaciones o Anulaciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/liberar-canastas',
        name: 'produccion-transacciones-liberar-canasta',
        component: () => import('@/views/pages/produccion/transacciones/liberarCanastas.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.liberar_canasta.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-liberar-canasta',
            pageTitle: 'Liberar Canasta',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Liberar Canasta',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/orden-produccion/:proforma_selected',
        name: 'produccion-transacciones-orden-produccion',
        props: true,
        component: () => import('@/views/pages/produccion/transacciones/ordenProduccion.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.orden_produccion.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-orden-produccion',
            pageTitle: 'Creación orden',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Creación de orden',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/dashboard',
        name: 'produccion-dashboard',
        component: () => import('@/views/pages/produccion/dashboard/dashboard.vue'),
        meta: {
            title: 'i18n:produccion.dashboard.title',
            resource: 'Produccion',
            action: 'ver-produccion-dashboard',
            pageTitle: 'Produccion',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Dashboard',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/reclutamiento',
        name: 'produccion-reclutamiento',
        component: () => import('@/views/pages/produccion/mantenimiento/ReclutamientoPersonal.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.reclutamiento_personal.title',
            resource: 'Produccion',
            action: 'ver-produccion-registro-reclutamiento',
            pageTitle: 'Datos Generales RECLUTAMIENTO PERSONAL',
            breadcrumb: [
                {
                    text: 'Reclutamiento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/repoteTapon',
        name: 'produccion-informe-tapon',
        component: () => import('@/views/pages/produccion/informes/repoteTapon.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_tapon.title',
            resource: 'Produccion',
            action: 'ver-produccion-informe-tapon',
            pageTitle: 'Reporte Tapon',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reporte Tapon',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/fraccionamiento-va',
        name: 'produccion-transacciones-fraccionamiento-va',
        component: () => import('@/views/pages/produccion/transacciones/FraccionamientoVA.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.fraccionamiento_va.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-fraccionamiento-va',
            pageTitle: 'Fraccionamiento VA',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Fraccionamiento VA',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteVA-Gavetas',
        name: 'produccion-reporte-VA-Gavetas',
        component: () => import('@/views/pages/produccion/informes/reporteVAGavetas.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_va_gavetas.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-VA-Gavetas',
            pageTitle: 'VA Gavetas',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'VA Gavetas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteLibrasreclasificadas',
        name: 'produccion-reporte-Librasreclasificadas',
        component: () => import('@/views/pages/produccion/informes/reporteLibrasReclasificadas.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_libras_reclasificadas.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-Librasreclasificadas',
            pageTitle: 'Libras reclasificadas manualmente',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Libras reclasificadas manualmente',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteCocido',
        name: 'produccion-reporte-LibrasCocido',
        component: () => import('@/views/pages/produccion/informes/reporteCocido.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_libras_cocido.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-LibrasCocido',
            pageTitle: 'Cocido',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Cocido',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteTratamiento',
        name: 'produccion-reporte-Tratamiento',
        component: () => import('@/views/pages/produccion/informes/reporteTratamiento.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_tratamiento.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-Tratamiento',
            pageTitle: 'Tratamiento',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Tratamiento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/aprobacionOrdenesPedido',
        name: 'produccion-transacciones-aprobacion-ordenes-pedido',
        component: () => import('@/views/pages/produccion/transacciones/aprobacionOrdenesPedido.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.aprobacion_ordenes_pedido.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-aprobacion-ordenes-pedido',
            pageTitle: 'Aprobacion Órdenes de Pedido',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Aprobacion Órdenes de Pedido',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/bandeja-entrada-proformas',
        name: 'produccion-transacciones-bandeja-entrada-proformas',
        component: () => import('@/views/pages/produccion/transacciones/bandejaEntradaProformas.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.bandeja_entrada_proformas.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-bandeja-entrada-proformas',
            pageTitle: 'Bandeja Entrada Proformas',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Bandeja Entrada Proformas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/bandeja-entrada-productos/:itemId?',
        name: 'produccion-transacciones-bandeja-entrada-productos',
        component: () => import('@/views/pages/produccion/transacciones/bandejaEntradaProductos.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.bandeja_entrada_productos.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-bandeja-entrada-productos',
            pageTitle: 'Bandeja Entrada Productos',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Bandeja Entrada Productos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteControldeBalanzas',
        name: 'produccion-reporte-ControldeBalanzas',
        component: () => import('@/views/pages/produccion/informes/reporteControldeBalanzas.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_control_balanzas.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-ControldeBalanzas',
            pageTitle: 'Control de Balanzas',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Control de Balanzas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteriaMensual',
        name: 'produccion-reporteriaMensual',
        component: () => import('@/views/pages/produccion/informes/reporteriaMensual.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporteria_mensual.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporteriaMensual',
            pageTitle: 'Reportería Mensual ',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reportería Mensual',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteriaDescabezado',
        name: 'produccion-reporteriaDescabezado',
        component: () => import('@/views/pages/produccion/informes/reporteriaDescabezado.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporteria_descabezado.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporteriaDescabezado',
            pageTitle: 'Reportería Descabezado ',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reportería de Libras de Cabeza Liquidadas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteListasDescabezado',
        name: 'produccion-reporteriaListasDescabezado_rrhh',
        component: () => import('@/views/pages/produccion/informes/reporteListasDescabezado.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_listas_descabezado.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporteriaListasDescabezado_rrhh',
            pageTitle: 'Reporte Listas Descabezado ',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Reportería de Listas Descabezado',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/produccion/mantenimiento/creacionItem/:itemId?',
        name: 'produccion-creacion-item',
        component: () => import('@/views/pages/produccion/mantenimiento/creacionItem.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.creacion_item.title',
            resource: 'Produccion',
            action: 'ver-produccion-creacion-item',
            pageTitle: 'Creación de Item',

            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Creación de Item',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/creacionOrdenProduccion/:proforma_selected?',
        name: 'produccion-creacion-orden',
        props: true,
        component: () => import('@/views/pages/produccion/mantenimiento/creacionOrdenProduccion.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.creacion_orden.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-creacion-orden-produccion',
            pageTitle: 'Creación de Ord. Prod.',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Creación de Orden Prod.',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/items',
        name: 'produccion-mantenimiento-items',
        component: () => import('@/views/pages/produccion/mantenimiento/itemProduccion.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.items.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-items',
            pageTitle: 'Items',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Items',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteConsumoHielo',
        name: 'produccion-reporte-ConsumoHielo',
        component: () => import('@/views/pages/produccion/informes/reporteConsumoHielo.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_consumo_hielo.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-consumohielo',
            pageTitle: 'Consumo de Hielo',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Consumo Hielo',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/agrupamientoVA',
        name: 'produccion-reporte-agrupamientoVA',
        component: () => import('@/views/pages/produccion/transacciones/agrupamientoVA.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.agrupamiento_va.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-agrupamientova',
            pageTitle: 'Agrupamiento de Etiquetas VA',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Agrupamiento de Etiquetas VA',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/agrupamientoBines',
        name: 'produccion-transacciones-agrupamientoBines',
        component: () => import('@/views/pages/produccion/transacciones/agrupamientoBines.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.agrupamiento_bines.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-agrupamientoBines',
            pageTitle: 'Agrupamiento de Bines',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Agrupamiento de Bines',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/coches',
        name: 'produccion-transacciones-coches',
        component: () => import('@/views/pages/produccion/transacciones/coches.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.coches.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-coches',
            pageTitle: 'Contenedor',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Contenedor',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/proformas',
        name: 'produccion-transacciones-proformas',
        component: () => import('@/views/pages/produccion/transacciones/proformaLiq.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.proformas.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-proformas',
            pageTitle: 'Proformas',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Proformas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteTratado',
        name: 'produccion-reporte-BodegaTratado',
        component: () => import('@/views/pages/produccion/informes/reporteTratado.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_tratado.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-BodegaTratado',
            pageTitle: 'Reporte Bodega VA-Tratado',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Bodega Tratado',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteDiferenciasMP',
        name: 'produccion-reporteDiferenciasMP',
        component: () => import('@/views/pages/produccion/informes/reporteDiferenciasMP.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_diferencias_mp.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporteDiferenciasMP',
            pageTitle: 'Diferencias de MP Liquidada vs. MP aplicada a VA.',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Diferencias de MP',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteDiferenciasPT',
        name: 'produccion-reporteDiferenciasPT',
        component: () => import('@/views/pages/produccion/informes/ReporteDiferenciasPt.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_diferencias_pt.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporteDiferenciasPT',
            pageTitle: 'Diferencias PT Fresco',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Diferencias PT Fresco',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteEstadoLoteF',
        name: 'produccion-reporteEstadoLoteF',
        component: () => import('@/views/pages/produccion/informes/reporteEstadoLoteF.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_estado_lote_f.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporteEstadoLoteF',
            pageTitle: 'Estado de Lotes Fresco',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Estado de Lotes Fresco',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reportesLibrasPendientes',
        name: 'produccion-reportesLibrasPendientes',
        component: () => import('@/views/pages/produccion/informes/reporteLibrasPendientes.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_libras_pendientes.title',
            resource: 'Produccion',
            action: 'ver-produccion-reportesLibrasPendientes',
            pageTitle: 'Reporte Libras Pendientes',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Libras Pendientes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/liquidacionEmbarque',
        name: 'produccion-transacciones-liquidacion-embarque',
        component: () => import('@/views/pages/produccion/transacciones/LiquidacionEmbarque.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.liquidacion_embarque.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-liquidacion-embarque',
            pageTitle: 'Liquidación',
            breadcrumb: [
                {
                    text: 'Embarque',
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/reembinado',
        name: 'produccion-transacciones-reembinado',
        component: () => import('@/views/pages/produccion/transacciones/Reembinado.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.reembinado.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-reembinado',
            pageTitle: 'Reembinamiento',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Reembinamiento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/transferencias-materia-prima',
        name: 'produccion-transacciones-transferencias-materia-prima',
        component: () => import('@/views/pages/produccion/transacciones/transferenciasMP.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.transferencias_materia_prima.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-transferencias-materia-prima',
            pageTitle: 'Transferencias Materia Prima',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Transferencias Materia Prima',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/solicitud_codigos',
        name: 'produccion-transacciones-solicitud_codigos',
        component: () => import('@/views/pages/produccion/transacciones/solicitudCodigos.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.solicitud_codigos.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-solicitud_codigos',
            pageTitle: 'Solicitud de Códigos',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Requerimientos de producción',
                },
                {
                    text: 'Solicitud de códigos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/gestion_solicitud_codigos',
        name: 'produccion-transacciones-gestion_solicitud_codigos',
        component: () => import('@/views/pages/produccion/transacciones/gestionSolicitudCodigos.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.gestion_solicitud_codigos.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-gestion_solicitud_codigos',
            pageTitle: 'Gestión de Solicitudes',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Requerimientos de producción',
                },
                {
                    text: 'Gestión de Solicitudes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/imprimir_solicitud_codigos',
        name: 'produccion-transacciones-imprimir_solicitud_codigos',
        component: () => import('@/views/pages/produccion/transacciones/imprimirSolicitudCodigos.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.imprimir_solicitud_codigos.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-imprimir_solicitud_codigos',
            pageTitle: 'Imprimir Solicitudes',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Requerimientos de producción',
                },
                {
                    text: 'Imprimir Solicitudes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/transferencias-materia-prima',
        name: 'produccion-informes-transferencias-materia-prima',
        component: () => import('@/views/pages/produccion/informes/reporteTransferenciaMP.vue'),
        meta: {
            title: 'i18n:produccion.informes.transferencias_materia_prima.title',
            resource: 'Produccion',
            action: 'ver-produccion-informes-transferencias-materia-prima',
            pageTitle: 'Transferencias Materia Prima',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Transferencias Materia Prima',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reportesBalanzasProfremar',
        name: 'produccion-reportesBalanzasProfremar',
        component: () => import('@/views/pages/produccion/informes/reportesBalanzasProfremar.vue'),
        meta: {
            title: 'i18n:proudccion.informes.reportes_balanzas_profremar.title',
            resource: 'Produccion',
            action: 'ver-produccion-reportesBalanzasProfremar',
            pageTitle: 'Reporte Control Balanzas Profremar',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Control Balanzas Profremar',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/areaMapeoVirtual',
        name: 'produccion-mantenimiento-area-mapeo-virtual',
        component: () => import('@/views/pages/produccion/mantenimiento/areaMapeoVirtual.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.area_mapeo_virtual.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-area-mapeo-virtual',
            pageTitle: 'Area de Mapeo Vritual',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Area de Mapeo Virtual',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteAgrupamientoBines',
        name: 'produccion-reporte-AgrupamientoBines',
        component: () => import('@/views/pages/produccion/informes/reporteAgrupamientoBines.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_agrupamiento_bines.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-AgrupamientoBines',
            pageTitle: 'Agrupamiento de Bines',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Agrupamiento de Bines',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteEtiquetasAgrupadasVA',
        name: 'produccion-reporte-EtiquetasAgrupadasVA',
        component: () => import('@/views/pages/produccion/informes/reporteEtiquetasAgrupadasVA.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_etiquetas_agrupadas_va.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-EtiquetasAgrupadasVA',
            pageTitle: 'Etiquetas agrupadas VA',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Etiquetas agrupadas VA',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteAgrupamientoLotes',
        name: 'produccion-reporte-AgrupamientoLotes',
        component: () => import('@/views/pages/produccion/informes/reporteAgrupamientoLotes.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_agrupamiento_lotes.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-AgrupamientoLotes',
            pageTitle: 'Agrupamiento Lotes',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Agrupamiento Lotes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteIndicadores',
        name: 'produccion-reporte-indicadores',
        component: () => import('@/views/pages/produccion/informes/reporteIndicadores.vue'),
        meta: {
            title: 'Indicadores',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-Indicadores',
            pageTitle: 'Indicadores',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Indicadores',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteProformas',
        name: 'produccion-reporte-Proformas',
        component: () => import('@/views/pages/produccion/informes/reporteProformas.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_proformas.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-Proformas',
            pageTitle: 'Proformas',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Proformas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteContenedores',
        name: 'produccion-reporte-Contenedores',
        component: () => import('@/views/pages/produccion/informes/reporteContenedores.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_contenedores.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-Contenedores',
            pageTitle: 'Contenedores',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Contenedores',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteSolicitudCodigos',
        name: 'produccion-reporte-SolicitudCodigos',
        component: () => import('@/views/pages/produccion/informes/reporteSolicitudCodigos.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_solicitudCodigos.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-SolicitudCodigos',
            pageTitle: 'Solicitud de Códigos',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Solicitud de Códigos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteSolicitudCodigosxLote',
        name: 'produccion-reporte-SolicitudCodigosxLote',
        component: () => import('@/views/pages/produccion/informes/reporteSolicitudCodLote.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporteSolicitudCodigosxLote.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-SolicitudCodigosxLote',
            pageTitle: 'Sol. Códigos x Lote ',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Sol. Códigos x Lote',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/reporteTipoLotes',
        name: 'produccion-reporte-TipoLotes',
        component: () => import('@/views/pages/produccion/informes/reporteTipoLotes.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_tiposlotes.title',
            resource: 'Produccion',
            action: 'ver-produccion-reporte-TipoLotes',
            pageTitle: 'Tipo de Lotes',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Tipo de Lotes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/registro-operatividad',
        name: 'produccion-reportes-registro-operatividad',
        component: () => import('@/views/pages/produccion/informes/reporteRegistroOperatividad.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_registro_operatividad.title',
            resource: 'Produccion',
            action: 'ver-produccion-reportes-registro-operatividad',
            pageTitle: 'Registro de Operatividad',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Registro de Operatividad',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/stock-produccion',
        name: 'produccion-reportes-stock-produccion',
        component: () => import('@/views/pages/produccion/informes/reporteStockXPlanta.vue'),
        meta: {
            title: 'i18n:produccion.informes.reporte_stock_produccion.title',
            resource: 'Produccion',
            action: 'ver-produccion-reportes-stock-produccion',
            pageTitle: 'Stock por Planta',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Stock por Planta',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/registro-operatividad',
        name: 'produccion-transacciones-registro-operatividad',
        component: () => import('@/views/pages/produccion/transacciones/registroOperatividad.vue'),
        meta: {
            title: 'i18n:produccion.transacciones.registro_operatividad.title',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-registro-operatividad',
            pageTitle: 'Registro de Operatividad',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Registro de Operatividad',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroTipoCongelacion',
        name: 'produccion-mantenimiento-tipo-congelacion',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroTipoCongelacion.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.tipo_congelacion.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-tipo-congelacion',
            pageTitle: 'Tipo Congelacion',
            breadcrumb: [
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Tipo Congelacion',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/produccion/mantenimiento/maestroNandina',
        name: 'produccion-mantenimiento-nandina',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroNandina.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.nandina.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-nandina',
            pageTitle: 'Nandina',
            breadcrumb: [
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Nandina',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroUnidad',
        name: 'produccion-mantenimiento-unidad',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroUnidad.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.unidad.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-unidad',
            pageTitle: 'Unidad',
            breadcrumb: [
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Unidad',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroUnidadMedida',
        name: 'produccion-mantenimiento-unidad-medida',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroUnidadMedida.vue'),
        meta: {
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-unidad-medida',
            // pageTitle: "Unidad Medida",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.unidad_medida',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/produccion/mantenimiento/registroOperatividad',
        name: 'produccion-mantenimiento-registro-operatividad',
        component: () => import('@/views/pages/produccion/mantenimiento/procesosOperatividad.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.registro_operatividad.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-registro-operatividad',
            pageTitle: 'Configuración de Procesos/Equipos de Operatividad',
            breadcrumb: [
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Procesos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroLinea',
        name: 'produccion-mantenimiento-linea',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroLinea.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.linea.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-linea',
            // pageTitle: "Linea",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.linea',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroSublinea',
        name: 'produccion-mantenimiento-sublinea',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroSublinea.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.sublinea.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-sublinea',
            // pageTitle: "Sublinea",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.sublinea',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroEspecie',
        name: 'produccion-mantenimiento-especie',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroEspecie.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.especie.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-especie',
            // pageTitle: "Especie",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.especie',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroTipoProducto',
        name: 'produccion-mantenimiento-tipo-producto',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroTipoProducto.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.tipo_producto.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-tipo-producto',
            // pageTitle: "Tipo Producto",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.tipo_producto',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroProcesoVA',
        name: 'produccion-mantenimiento-proceso-va',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroProcesoVA.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.proceso_va.title',
            Produccion: 'Produccion',
            action: 'ver-produccion-mantenimiento-proceso-va',
            // pageTitle: "Proceso VA",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.proceso_va',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroEstadoProducto',
        name: 'produccion-mantenimiento-estado-producto',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroEstadoProducto.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.estado_producto.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-estado-producto',
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.estado_producto',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroCalidad',
        name: 'produccion-mantenimiento-calidad',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroCalidad.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.calidad.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-calidad',

            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.calidad',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroMateriaPrima',
        name: 'produccion-mantenimiento-materia-prima',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroMateriaPrima/maestroMateriaPrima.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.materia_prima.title',
            Produccion: 'Produccion',
            action: 'ver-produccion-mantenimiento-materia-prima',
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.materia_prima',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroTalla',
        name: 'produccion-mantenimiento-talla',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroTalla.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.talla.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-talla',
            // pageTitle: "Talla",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.talla',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroCertificacion',
        name: 'produccion-mantenimiento-certificacion',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroCertificacion.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.certificacion.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-certificacion',
            // pageTitle: "Certificacion",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.certificacion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroTratamiento',
        name: 'produccion-mantenimiento-tratamiento',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroTratamiento.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.tratamiento.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-tratamiento',
            // pageTitle: "Tratamiento",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.tratamiento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroMarca',
        name: 'produccion-mantenimiento-marca',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroMarca.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.marca.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-marca',
            // pageTitle: "Marca",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.marca',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroPresentacion',
        name: 'produccion-mantenimiento-presentacion',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroPresentacion.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.presentacion.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-presentacion',
            // pageTitle: "presentacion",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.presentacion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroTipoEmpaque',
        name: 'produccion-mantenimiento-tipo-empaque',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroTipoEmpaque.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.tipo_empaque.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-tipo-empaque',
            // pageTitle: "Tipo Empaque",
            breadcrumb: [
                {
                    text: 'produccion.menu_title',
                },
                {
                    text: 'global.menu.mantenimiento',
                },
                {
                    text: 'produccion.mantenimiento.tipo_empaque',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/mantenimiento/maestroItemsPT',
        name: 'produccion-mantenimiento-item-pt',
        component: () => import('@/views/pages/produccion/mantenimiento/maestroItemsPT/maestroItemsPT.vue'),
        meta: {
            title: 'i18n:produccion.mantenimiento.item_pt.title',
            resource: 'Produccion',
            action: 'ver-produccion-mantenimiento-item-pt',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Items PT',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/configuracion-pt-conteo',
        name: 'produccion-configuracion-pt-conteo',
        component: () => import('@/views/pages/produccion/configuracion/ConteoPT.vue'),
        meta: {
            title: 'i18n:produccion.configuracion.pt_conteo.titulo',
            resource: 'Produccion',
            action: 'ver-produccion-configuracion-pt-conteo',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Configuracion',
                },
                {
                    text: 'Conteo PT',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/dashboard-pt-conteo',
        name: 'produccion-dashboard-pt-conteo',
        component: () => import('@/views/pages/produccion/dashboard/ConteoPT.vue'),
        meta: {
            title: 'i18n:produccion.dashboard.pt_conteo',
            resource: 'Produccion',
            action: 'ver-produccion-dashboard-pt-conteo',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Dashboard',
                },
                {
                    text: 'Conteo PT',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/transacciones/registro-horas-maquina',
        name: 'produccion-transacciones-registro-horas-maquina',
        component: () => import('@/views/pages/produccion/transacciones/RegistroHorasMaquina.vue'),
        meta: {
            title: 'Registro de Horas Máquina',
            resource: 'Produccion',
            action: 'ver-produccion-transacciones-registro-horas-maquina',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Registro de Horas Máquina',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/registro-horas-maquina',
        name: 'produccion-informes-registro-horas-maquina',
        component: () => import('@/views/pages/produccion/informes/RegistroHorasMaquina.vue'),
        meta: {
            title: 'Registro de Horas Máquina',
            resource: 'Produccion',
            action: 'ver-produccion-informes-registro-horas-maquina',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'Registro de Horas Máquina',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/pesos-rechazo',
        name: 'produccion-informes-pesos-rechazo',
        component: () => import('@/views/pages/produccion/informes/PesosRechazo.vue'),
        meta: {
            title: 'i18n:produccion.informes.pesos_rechazo.titulo',
            resource: 'Produccion',
            action: 'ver-produccion-informes-pesos-rechazo',
            pageTitle: 'produccion.informes.pesos_rechazo.titulo',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'produccion.informes.pesos_rechazo.titulo',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/produccion/informes/libras-procesadas',
        name: 'produccion-informes-libras-procesadas',
        component: () => import('@/views/pages/produccion/informes/LibrasProcesadas.vue'),
        meta: {
            title: 'i18n:produccion.informes.libras_procesadas.titulo',
            resource: 'Produccion',
            action: 'ver-produccion-informes-libras-procesadas',
            pageTitle: 'produccion.informes.libras_procesadas.titulo',
            breadcrumb: [
                {
                    text: 'Produccion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'produccion.informes.libras_procesadas.titulo',
                    active: true,
                },
            ],
        },
    },
]
